<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    :title="$t('start_learning.get_email_link_modal.title')"
  >
    <template v-slot:body>
      <el-form class="auth-form" :model="form" :rules="rules" ref="form" @change.native="onFormChange">
        <elsa-input
          name="email"
          :label="$t('start_learning.get_email_link_modal.email_field.label')"
          :placeholder="$t('start_learning.get_email_link_modal.email_field.placeholder')"
          v-model.trim.lazy="form.email"
          ref="emailField"
        >
          {{ $t('start_learning.get_email_link_modal.email_field.label') }}
        </elsa-input>
        <elsa-select
          popper-class="phone-type"
          name="phoneType"
          :label="$t('start_learning.get_email_link_modal.phone_type_field.label')"
          :placeholder="$t('start_learning.get_email_link_modal.phone_type_field.placeholder')"
          :options="phoneTypes"
          v-model.lazy="form.phoneType"
          @change="onFormChange"
        />
      </el-form>
    </template>
    <template v-slot:footer>
      <primary-button
        @click.native="handleSendEmailLink"
        ref="submit"
        disabled
      >
        {{ $t('start_learning.get_email_link_modal.get_email_link') }}
      </primary-button>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import ElsaInput from '@/components/common/Input'
  import ElsaSelect from '@/components/common/Select'
  import {handleSubmitButtonState, isPropEmpty } from '@/helpers/formValidationHelper'
  import { path, always } from 'ramda'
  import { successMessage, warningMessage } from '../../../utils/messages'
  import phoneTypes from '@/constants/phoneTypes'

  export default {
    components: {
      Modal,
      PrimaryButton,
      ElsaInput,
      ElsaSelect
    },
    data() {
      return {
        form: {
          email: '',
          phoneType: ''
        },
        rules: {
          email: { type: 'email', message: this.$t('start_learning.get_email_link_modal.email_field.validation'), trigger: 'blur' }
        }
      }
    },
    methods: {
      onFormChange() {
        const invalid = isPropEmpty('email')(this.form) ||
                        isPropEmpty('phoneType')(this.form)
        handleSubmitButtonState(this.$refs.submit.$el, !invalid)
      },
      async handleSendEmailLink() {
        const email = path(['form', 'email'])(this)
        const application = path(['form', 'phoneType'])(this)

        try {
          await this.$axios.post('/v1/invitations/email', { email, application })
        } catch {
          return warningMessage(this.$t('start_learning.get_email_link_modal.warning'))(this)
        }

        this.$emit('closed')
        this.$refs.form.resetFields()
        this.form = {}
        return successMessage(this.$t('start_learning.get_email_link_modal.success'))(this)
      }
    },
    computed: {
      phoneTypes: always(phoneTypes)
    },
    watch: {
      ['$attrs.dialogVisible'](visible) {
        if(visible) {
          this.form = {
            email: this.$store.state.user.userInfo.email
          }
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog.elsa-modal {
    width: 587px;
    .el-form-item__label {
      text-transform: none;
    }
  }

  form {
    width: 320px;
  }

  ::v-deep .el-form > div {
    padding: 8px 0;
  }

</style>
